import { Box } from "@components/Layout"
import styled, { css, keyframes } from "styled-components"

export const Shadow = styled.span`
  position: absolute;
  bottom: 30%;
  width: 50%;
  height: 1rem;
  border-radius: 100%;
  background: transparent;
  display: block;
  box-shadow: 0 2.75rem 2rem rgba(0, 0, 0, 0.3);
  left: 50%;
  transform: translateX(-50%);
  z-index: -1;
`

export const ImageWrap = styled.div`
  position: relative;
  height: 100%;
`

export const Reload = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  color: ${(p) => p.theme.colors.text.light};
`

export const fadeIn = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`

export const Preloader = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  opacity: 0;
  animation: ${fadeIn} 0.3s linear 1;
  animation-delay: 0.2s;

  svg {
    height: 4rem;
    width: 4rem;
    stroke: ${(p) => p.theme.colors.purple};
  }
`

export const Wrapper = styled.div`
  max-width: 100%;
  max-height: 100%;
  position: absolute;
  width: 32rem;
  height: 32rem;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  &::selection {
    background: transparent;
  }
`

// @ts-ignore
export const LoaderBar = styled(Box)`
  svg {
    width: 3rem;
    height: 3rem;
    stroke: ${(p) => p.theme.colors.purple};
  }
  position: absolute;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  width: 100%;
`

export const Image = styled.img<{
  variant: "earring-left" | "earring-right" | false
  isElevated?: boolean
}>`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -45%);
  width: 75%;
  height: auto;
  max-width: 75%;
  pointer-events: none;
  object-fit: contain;
  user-select: none;

  ${(p) =>
    p.variant === "earring-left" &&
    css`
      left: 35%;
    `}

  ${(p) =>
    p.variant === "earring-right" &&
    css`
      left: initial;
      right: 35%;
      transform: translate(50%, -45%);
    `}

  ${(p) =>
    p.isElevated &&
    css`
      z-index: 1;
    `}
`
